import { union } from 'lodash';
import {
  communicationDetailPage,
  communicationListPage,
  userPage,
  tagManagementPage,
  thirdPartyPage,
  localizationPage,
  paymentDetailPage,
  paymentListPage,
  logisticsSettingPage,
  destinationPage,
  packagePage,
  shoppingZonePage,
  pickupLocationPage,
  logisticsWarehouseSettingPage,
  logisticsWarehouseCourierAccountSettingPage,
  logisticsWarehousePackingSlipSettingPage,
  logisticsWarehouseDeliverMethodSettingPage,
  logisticsWarehouseParcelLockerSettingPage,
  taxDetailPage,
  taxListPage,
  orderSettingPage,
  productSettingPage,
  currencyPage,
  invoicePage,
  developerPage,
  storeDetailPage,
  linkLibraryDetailPage,
  linkLibraryListPage,
  fileLibraryDetailPage,
  fileLibraryListPage,
  settingGridPage,
  giftCardDetailPage,
  giftCardListPage,
  shoppingCartTemplateDetailPage,
  shoppingCartTemplateListPage,
  subscriptionBuyDetailPage,
  subscriptionBuyListPage,
  orderDetailPage,
  ordersListPage,
  salesChannelGridPage,
  tagDetailPage,
  tagListPage,
  dbSettingPage,
  customerDetailPage,
  customerListPage,
  allCustomersGridPage,
  voucherDetailPage,
  voucherListPage,
  reviewDetailPage,
  reviewListPage,
  inventoryDetailPage,
  inventoryListPage,
  stockDetailPage,
  stockListPage,
  productDetailPage,
  productListPage,
  communicationAuditTrailListPage,
  communicationAuditTrailDetailPage,
  analyticsDashboardPage,
  analyticsSubscriptionListPage,
  analyticsSubscriptionDetailPage,
  analyticsReportListPage,
  analyticsReportDetailPage,
} from './storePermissions';

const orderParent = union(
  ordersListPage,
  orderDetailPage,
  shoppingCartTemplateListPage,
  shoppingCartTemplateDetailPage,
  giftCardListPage,
  giftCardDetailPage,
  subscriptionBuyListPage,
  subscriptionBuyDetailPage,
);

const orders = union(ordersListPage, orderDetailPage);

const subscriptionBuy = union(
  subscriptionBuyListPage,
  subscriptionBuyDetailPage,
);

const shoppingCartTemplate = union(
  shoppingCartTemplateListPage,
  shoppingCartTemplateDetailPage,
);

const giftCard = union(giftCardListPage, giftCardDetailPage);

const productParent = union(
  productListPage,
  inventoryListPage,
  stockListPage,
  reviewListPage,
  productDetailPage,
  stockDetailPage,
  inventoryDetailPage,
  reviewDetailPage,
);

const product = union(productListPage, productDetailPage);

const stockIn = union(productListPage, productDetailPage);

const inventory = union(inventoryListPage, inventoryDetailPage);

const review = union(reviewListPage, reviewDetailPage);

const voucher = union(voucherDetailPage, voucherListPage);

const auditTrailParent = union(
  communicationAuditTrailListPage,
  communicationAuditTrailDetailPage,
);

const communication = union(
  communicationAuditTrailListPage,
  communicationAuditTrailDetailPage,
);

const analyticsParent = union(
  analyticsSubscriptionListPage,
  analyticsSubscriptionDetailPage,
  analyticsReportListPage,
  analyticsReportDetailPage,
  //analyticsDashboardPage,
);

const reportSubscription = union(
  analyticsSubscriptionListPage,
  analyticsSubscriptionDetailPage,
);

const reports = union(analyticsReportListPage, analyticsReportDetailPage);

const dashboard = union(analyticsDashboardPage);

const customerGridParent = union(
  allCustomersGridPage,
  tagDetailPage,
  tagListPage,
  dbSettingPage,
  customerDetailPage,
  customerListPage,
);

const customerList = union(customerListPage, customerDetailPage);

const databaseSetting = union(dbSettingPage);

const customerTag = union(tagDetailPage, tagListPage);

const salesChannelGrid = salesChannelGridPage;

const settings = union(
  settingGridPage,
  fileLibraryListPage,
  fileLibraryDetailPage,
  storeDetailPage,
  communicationDetailPage,
  communicationListPage,
  userPage,
  tagManagementPage,
  thirdPartyPage,
  localizationPage,
  paymentDetailPage,
  paymentListPage,
  logisticsSettingPage,
  destinationPage,
  packagePage,
  shoppingZonePage,
  logisticsWarehousePackingSlipSettingPage,
  logisticsWarehouseCourierAccountSettingPage,
  logisticsWarehouseDeliverMethodSettingPage,
  logisticsWarehouseParcelLockerSettingPage,
  pickupLocationPage,
  logisticsWarehouseSettingPage,
  taxDetailPage,
  taxListPage,
  orderSettingPage,
  productSettingPage,
  currencyPage,
  invoicePage,
  developerPage,
  linkLibraryDetailPage,
  linkLibraryListPage,
);

export {
  settings,
  salesChannelGrid,
  customerTag,
  databaseSetting,
  customerList,
  customerGridParent,
  analyticsParent,
  communication,
  auditTrailParent,
  voucher,
  review,
  inventory,
  stockIn,
  product,
  productParent,
  giftCard,
  shoppingCartTemplate,
  subscriptionBuy,
  orders,
  orderParent,
  reportSubscription,
  reports,
  dashboard,
};
